import { GenericValue } from 'hisng';
import { JobApplication } from './../../model/jobapplication';
import { Field } from './../../model/bwmconfig';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component( {
    selector: 'erp-jobapplication-field',
    templateUrl: './jobapplication-field.component.html'
} )
export class JobApplicationFieldComponent implements OnInit {

    @Input() jobApplication?: JobApplication;
    @Input() field?: Field;
    @Input() readonly = false;
    @Output() readonly valueChange = new EventEmitter<JobApplication>();

    ngOnInit(): void {
    }

    onChange( _: number | string | GenericValue | boolean | Date ): void {
        // Die Eingabefelder für den Grad der Behinderung und des Teilzeitumfangs sollen geleert werden, wenn die entsprechende
        // Checkbox abgewählt wurde.
        if ( !this.jobApplication?.disability && this.jobApplication?.disabilityInPercent) {
            this.jobApplication.disabilityInPercent = undefined;
        }

        if ( !this.jobApplication?.parttime && this.jobApplication?.partTimeScope) {
            this.jobApplication.partTimeScope = undefined;
        }

        this.valueChange.emit( this.jobApplication );
    }
}
